<template>
  <div data-app>
    <div class="row">
      <div class="md-layout input-layout">
        <md-dialog-alert
          :md-active.sync="error_dialog.show"
          :md-title="error_dialog.title"
          :md-content="error_dialog.content"
        />
        <!-- Date ranges field -->
        <validated-select-input
        label="Date Range"
        :options="ranges"
        v-model="range"
        class="md-layout-item md-small-size-100 md-size-20"
        >
        </validated-select-input>

        <!-- From date field-->
        <div class="md-layout-item md-small-size-100 md-size-20">
        <md-datepicker
          md-immediately
          v-model="advance_search_application.start_date"
          :md-model-type="String"
        >
        <label>From date</label>
        </md-datepicker>
        </div>

        <!-- To date field-->
        <div class="md-layout-item md-small-size-100 md-size-20">
        <md-datepicker
          md-immediately
          v-model="advance_search_application.end_date"
          :md-model-type="String"
        >
          <label>To date</label>
        </md-datepicker>
        </div>
        <div class="md-layout-item md-small-size-100 md-size-20">
        <md-datepicker
          md-immediately
          v-model="advance_search_application.status_start_date"
          :md-model-type="String"
        >
        <label>Status From date</label>
        </md-datepicker>
        </div>
        <div class="md-layout-item md-small-size-100 md-size-20">
        <md-datepicker
          md-immediately
          v-model="advance_search_application.status_end_date"
          :md-model-type="String"
        >
          <label>Status To date</label>
        </md-datepicker>
        </div>
      </div>
      <!-- pods field -->
      <div class="md-layout-item md-small-size-100 md-size-9">
        <v-autocomplete
          v-model="advance_search_application.pods"
          :background-color="setBgColorDropdown('pods')"
          :items="getPods"
          dense
          chips
          filled
          small-chips
          @mouseover.native="toggleDropdownPreview('pods', true)"
          @mouseout.native="toggleDropdownPreview('pods', false)"
          multiple
          item-value="id"
          item-text="description"
          label="Pods"
          ref="pods"
          @blur="blurDropdown('pods')"
          @change="handlePodSelectionChange"
        >
          <template #selection="{ item }">
            <v-chip
              ref="pods_chips"
              :active="showDropdown.pods"
            >{{ item.name }}</v-chip>
          </template>
          <template v-slot:prepend-item>
              <v-list-item
                ripple
                @mousedown.prevent
                @click="toggle('pods')"
              >
                    <v-list-item-action>
                      <v-icon>
                        {{ podIcon }}
                      </v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>
                        Select All
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
          </template>
        </v-autocomplete>
      </div>

      <!-- agent field-->
      <div class="md-layout-item md-small-size-100 md-size-9">
        <v-autocomplete
          v-model="filter_values.agents"
          :items="getAgents"
          :background-color="setBgColorDropdown('agents',true)"
          dense
          chips
          filled
          small-chips
          label="Agent"
          multiple
          item-value="id"
          item-text="name"
          :open-on-clear="true"
          ref="agents"
          @blur="blurDropdown('agents')"
          @mouseover.native="toggleDropdownPreview('agents', true)"
          @mouseout.native="toggleDropdownPreview('agents', false)"
        >
          <template #selection="{ item }">
            <v-chip
              :active="showDropdown.agents"
            >{{ item.name }}</v-chip>
          </template>
        </v-autocomplete>
      </div>
      <!-- broker field -->
      <div class="md-layout-item md-small-size-100 md-size-9">
        <v-autocomplete
          v-model="filter_values.brokers"
          :items="getBrokers"
          :background-color="setBgColorDropdown('brokers',true)"
          dense
          chips
          filled
          small-chips
          multiple
          item-value="id"
          item-text="name"
          label="Broker"
          ref="brokers"
          @blur="blurDropdown('brokers')"
          @mouseover.native="toggleDropdownPreview('brokers', true)"
          @mouseout.native="toggleDropdownPreview('brokers', false)"
        >
          <template #selection="{ item }">
            <v-chip
              :active="showDropdown.brokers"
            >{{ item.name }}
            </v-chip>
          </template>
          <template v-slot:item="{ item }">
            <v-list-item
              ripple
              @mousedown.prevent
              @click="toggleBroker(item.id)"
            >
              <v-list-item-action>
                <v-icon>
                  {{ brokerIcon(item.id) }}
                </v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title
                :style="{
                  color: item.status_tag === 'Inactive' ? 'gray' : 'inherit',
                  fontStyle: item.status_tag === 'Inactive' ? 'italic' : 'normal'
                }">
                  {{ item.name }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
          <template v-slot:prepend-item>
            <v-list-item
              ripple
              @mousedown.prevent
              @click="toggle('brokers')"
            >
              <v-list-item-action>
                <v-icon>
                  {{ brokerIcon() }}
                </v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  Select All
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-autocomplete>
      </div>

      <!-- referrer field-->
      <div class="md-layout-item md-small-size-100 md-size-9">
        <v-autocomplete
          v-model="filter_values.introducers"
          :items="getIntroducers"
          :background-color="setBgColorDropdown('introducers',true)"
          dense
          chips
          filled
          small-chips
          label="Referrer"
          multiple
          item-value="id"
          item-text="name"
          :open-on-clear="true"
          ref="referrers"
          @blur="blurDropdown('referrers')"
          @mouseover.native="toggleDropdownPreview('referrers', true)"
          @mouseout.native="toggleDropdownPreview('referrers', false)"
        >
          <template #selection="{ item }">
            <v-chip
              :active="showDropdown.referrers"
            >{{ item.name }}</v-chip>
          </template>
        </v-autocomplete>
      </div>

      <!-- lender field-->
      <div class="md-layout-item md-small-size-100 md-size-9">
        <v-autocomplete
          v-model="filter_values.lenders"
          :items="getLenders"
          :background-color="setBgColorDropdown('lenders',true)"
          dense
          filled
          chips
          small-chips
          label="Lenders"
          multiple
          item-value="id"
          item-text="name"
          :open-on-clear="true"
          ref="lenders"
          @blur="blurDropdown('lenders')"
          @mouseover.native="toggleDropdownPreview('lenders', true)"
          @mouseout.native="toggleDropdownPreview('lenders', false)"
        >
          <template #selection="{ item }">
            <v-chip
              :active="showDropdown.lenders"
            >{{ item.name }}</v-chip>
          </template>
        </v-autocomplete>
      </div>

      <!-- asset type field -->
      <div class="md-layout-item md-small-size-100 md-size-13">
        <v-autocomplete
          v-model="loan_asset_types"
          :items="getAssetTypes"
          :background-color="setBgColorDropdown('loan_asset_types')"
          dense
          chips
          filled
          small-chips
          label="Asset type"
          multiple
          item-value="id"
          item-text="name"
          :open-on-clear="true"
          ref="asset_types"
          @blur="blurDropdown('asset_types')"
          @mouseover.native="toggleDropdownPreview('asset_types', true)"
          @mouseout.native="toggleDropdownPreview('asset_types', false)"
        >
          <template #selection="{ item }">
            <v-chip
              :active="showDropdown.asset_types"
            >{{ item }}</v-chip>
          </template>
        </v-autocomplete>
      </div>

      <!-- stage/status field -->
      <div class="md-layout-item md-small-size-100 md-size-13">
        <v-autocomplete
          v-model="advance_search_application.statuses"
          :items="getAppStatusTypes"
          :background-color="setBgColorDropdown('statuses')"
          dense
          filled
          chips
          small-chips
          label="Stage/Status"
          multiple
          item-value="id"
          :item-text="getStageStatus"
          :open-on-clear="true"
          ref="statuses"
          @blur="blurDropdown('statuses')"
          @mouseover.native="toggleDropdownPreview('statuses', true)"
          @mouseout.native="toggleDropdownPreview('statuses', false)"
        >
          <template #selection="{ item }">
            <v-chip
              :active="showDropdown.statuses"
            >{{ item.stage + '/' + item.status }}</v-chip>
          </template>
          <template v-slot:prepend-item>
            <v-list-item
              ripple
              @mousedown.prevent
              @click="toggle('statuses')"
            >
              <v-list-item-action>
                <v-icon>
                  {{ statusIcon }}
                </v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  Select All
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
          <template v-slot:selection="{ index }" v-if="allStatus">
            <v-chip v-if="index === 0">
              <span>Select All</span>
            </v-chip>
          </template>
        </v-autocomplete>
      </div>

      <!-- applicant type field -->
      <div class="md-layout-item md-small-size-100 md-size-13">
        <v-select
          v-model="advance_search_application.applicant_type"
          :items="['All', 'Consumer', 'Commercial']"
          :background-color="advance_search_application.applicant_type !== null ? 'lightgreen' : undefined"
          dense
          filled
          chips
          small-chips
          label="Applicant Type"
          :open-on-clear="true"
          ref="applicant_type"
          @blur="blurDropdown('applicant_type')"
          @mouseover.native="toggleDropdownPreview('applicant_type', true)"
          @mouseout.native="toggleDropdownPreview('applicant_type', false)"
        >
          <template #selection="{ item }">
            <v-chip
              :active="showDropdown.applicant_type"
            >{{ item }}</v-chip>
          </template>
        </v-select>
      </div>

      <!-- Asset filters -->
      <div v-if="showAssetFilters" class="md-layout input-layout" style="padding-bottom: 20px;">
        <!-- Make -->
        <validated-autocomplete-input
          class="md-layout-item md-small-size-100 md-size-20"
          label="Make"
          v-model="advance_search_application.model_make"
          :options="all_makers"
        >
        </validated-autocomplete-input>
        <!-- Model -->
        <validated-autocomplete-input
          class="md-layout-item md-small-size-30 md-size-20"
          label="Model"
          v-model="advance_search_application.model"
          :options="models_make"
        >
        </validated-autocomplete-input>
        <!-- Model Year -->
        <validated-autocomplete-input
          class="md-layout-item md-small-size-100 md-size-20"
          label="Model Year"
          v-model="advance_search_application.model_year"
          :options="options.model_years"
          force
        >
        </validated-autocomplete-input>
      </div>
    </div>

    <md-card-actions>
      <loading-icon-text-button
      class="md-primary md-sm"
      icon="save"
      :loading="false"
      @click="saveFilters"
      >
      Save Filters & Apply
      </loading-icon-text-button>
      <loading-icon-text-button
      class="md-primary md-sm"
      icon="restart_alt"
      :loading="false"
      @click="resetFilters"
      >
      Reset
      </loading-icon-text-button>
      <md-button class="md-primary md-sm" @click="applyFilter()">Apply</md-button>
    </md-card-actions>
  </div>
</template>

<script>
import ValidatedAutocompleteInput from "@/components/ValidatedInput/ValidatedAutocompleteInput";
import ValidatedSelectInput from "../ValidatedInput/ValidatedSelectInput.vue";
import {mapGetters} from "vuex";
import LoadingIconTextButton from "@/components/LoadingIconTextButton";

export default {
  components: {
    ValidatedAutocompleteInput,
    ValidatedSelectInput,
    LoadingIconTextButton,
  },
  methods: {
    toggle (type) {
      if (type == 'pods') {
        this.$nextTick(() => {
        if (this.allPods) {
          this.advance_search_application.pods = []
        } else {
          this.searchPods = this.getPods;
          this.advance_search_application.pods = [];
            for (let i in this.searchPods) {
              this.advance_search_application.pods.push(this.searchPods[i].id)
            }
          }
        });
      } else if (type == 'brokers') {
        this.$nextTick(() => {
        if (this.allBrokers) {
          this.filter_values.brokers = []
        } else {
            this.searchBrokers = this.getBrokers;
            this.filter_values.brokers = [];
            for (let i in this.searchBrokers) {
              this.filter_values.brokers.push(this.searchBrokers[i].id)
            }
          }
        });
      } else if (type == 'statuses') {
        this.$nextTick(() => {
        if (this.allStatus) {
          this.advance_search_application.statuses = []
        } else {
            this.searchStatus = this.getAppStatusTypes;
            this.advance_search_application.statuses = [];
            for (let i in this.searchStatus) {
              this.advance_search_application.statuses.push(this.searchStatus[i].id)
            }
          }
        });
      }
    },
    handlePodSelectionChange(values) {
        this.$nextTick(() => {
            this.searchPods = this.getPods;
            this.advance_search_application.pods = [];
            this.advance_search_application.child_pods = [];
            for (let i in values) {
                for (let x in this.searchPods) {
                    if (this.searchPods[x].parent_id == values[i] && !this.advance_search_application.child_pods.includes(values[i])) {
                        this.advance_search_application.child_pods.push(values[i]);
                        if (!this.advance_search_application.pods.includes(values[i])) {
                            this.advance_search_application.pods.push(values[i])
                        }
                    } else if (this.searchPods[x].id == values[i] && !this.advance_search_application.pods.includes(values[i])) {
                        this.advance_search_application.pods.push(values[i])
                    }
                }
            }
            this.temporaryPodSelection = this.advance_search_application.pods;
            this.temporaryChildPodSelection = this.advance_search_application.child_pods;
        });
    },
    toggleBroker(brokerId) {
      this.$nextTick(() => {
        if (this.filter_values.brokers.includes(brokerId)) {
          this.filter_values.brokers = this.filter_values.brokers.filter(id => id !== brokerId);
        } else {
          this.filter_values.brokers.push(brokerId);
        }
      });
    },
    brokerIcon(brokerId = null) {
      if (brokerId === null) {
        // Case 1: "Select All" broker selection logic
        if (this.allBrokers) return "mdi-close-box";
        if (this.someBrokers) return "mdi-minus-box";
        return "mdi-checkbox-blank-outline";
      }

      // Case 2: Individual broker selection logic
      return this.filter_values.brokers.includes(brokerId) ? "mdi-checkbox-marked" : "mdi-checkbox-blank-outline";
    },
    getStageStatus(item) {
      return item.stage + '/' + item.status
    },
    setAssetTypes(new_asset_types) {
      if (new_asset_types.length === 0) {
        this.advance_search_application.loan_asset_types = [];
      }
      this.advance_search_application.loan_asset_types = new_asset_types.map(
        asset_type_name => this.mapAssetType(asset_type_name)
      );

      if (new_asset_types.includes('Vehicle') && this.userHasRole("super-admin")) {
        this.showAssetFilters = true;
        this.fetch_all_make()
      } else {
        this.advance_search_application.model_year = null;
        this.advance_search_application.model_make = null;
        this.advance_search_application.model = null;
        this.showAssetFilters = false;
      }

    },
    mapAssetType(asset_type_name) {
      switch (asset_type_name) {
        case 'Personal Secured':
          return 'S';
        case 'Personal Unsecured':
          return 'P';
        default:
          return asset_type_name[0].toUpperCase();
      }
    },
    setDateRange(range) {
      switch (range) {
        case 'lastWeek':
          let d = new Date()

          // get the day
          d.getDay()
          // calculate the diff to the last sunday
          let daysToLastSunday = d.getDay()
          d.setDate(d.getDate() - daysToLastSunday)
          // subtract a week
          d.setDate(d.getDate() - 7)
          this.advance_search_application.start_date = this.dateToString(d)
          // calculate the diff from that date to the next sunday
          d.setDate(d.getDate() + 7)
          this.advance_search_application.end_date = this.dateToString(d)

          break
        case 'thisWeek':
          d = new Date()

           // get the day
          d.getDay()
          // calculate the diff to the last sunday
          daysToLastSunday = d.getDay()
          d.setDate(d.getDate() - daysToLastSunday)

          this.advance_search_application.start_date = this.dateToString(d)
          // calculate the diff from that date to the next sunday
          d.setDate(d.getDate() + 7)
          this.advance_search_application.end_date = this.dateToString(d)

          break
        case 'month':
          d = new Date()

          const firstDayOfLastMonth = new Date(d.getFullYear(), d.getMonth() - 1, 1);
          this.advance_search_application.start_date = this.dateToString(firstDayOfLastMonth)

          const lastDayOfLastMonth = new Date(d.getFullYear(), d.getMonth(), 0);
          this.advance_search_application.end_date = this.dateToString(lastDayOfLastMonth)

          break
        case 'quarter':
          d = new Date()
          d.setMonth(d.getMonth() - 3)
          this.advance_search_application.start_date = this.dateToString(d)

          d.setMonth(d.getMonth() + 3)
          this.advance_search_application.end_date = this.dateToString(d)

          break
        case 'allTime':
          this.advance_search_application.start_date = null;
          this.advance_search_application.end_date  = null;
          break
      }
    },
    dateToString(date) {
      const year = date.getFullYear()
      const dayOfMonth = (date.getDate() >= 10) ? date.getDate() : '0' + date.getDate().toString()
      const month = (date.getMonth() + 1 >= 10) ? date.getMonth() + 1 : '0' + (date.getMonth() + 1).toString()

      return `${year}-${month}-${dayOfMonth}`
    },
    applyFilter() {
      this.advance_search_application.active = true;
      this.$emit("searchapply", this.advance_search_application);
    },
    async saveFilters() {
      try {
        await this.$store.dispatch('save_basket_search_filter');
        this.applyFilter();
      }
      catch (error) {
        this.showError('Failed to save filters', error.response.data)
      }
    },
    setBgColorDropdown() {
      this.advance_search_application.pods.length > 0 ? this.bgColorClass = 'lightgreen' : this.bgColorClass = undefined;
    },
    setAdvancedSearchApplication(type="") {
      if (!!type) {
        // copy filter_values to advance_search_application
        this.advance_search_application[type] = [...this.filter_values[type]];
        // 0 is id of Applications without Broker/Introducer/Lender
        let index = this.advance_search_application[type].indexOf(0);
        if (index > -1) {
          // remove 0 from advance_search_application
          this.advance_search_application[type].splice(index, 1);
        }
        // set flag
        this.setEmptySearch(type, (index > -1));
      }
    },
    setEmptySearch(type="", value=false) {
      if (!!type) {
        switch(type) {
          case "brokers":
            this.advance_search_application['get_empty_broker'] = value;
            break;
          case "introducers":
            this.advance_search_application['get_empty_introducer'] = value;
            break;
          case "lenders":
            this.advance_search_application['get_empty_lender'] = value;
            break;
          case "agents":
            this.advance_search_application['get_empty_agent'] = value;
            break;
        }
      }
    },
    setExistedFilterValues() {
      if (this.advance_search_application) {
        if (this.advance_search_application.brokers) {
          this.filter_values.brokers = [...this.advance_search_application.brokers];
        }
        if (this.advance_search_application.introducers) {
          this.filter_values.introducers = [...this.advance_search_application.introducers];
        }
        if (this.advance_search_application.lenders) {
          this.filter_values.lenders = [...this.advance_search_application.lenders];
        }
        if (this.advance_search_application.agents) {
          this.filter_values.agents = [...this.advance_search_application.agents];
        }
        if (this.advance_search_application.get_empty_broker) {
          this.filter_values.brokers.unshift(0);
        }
        if (this.advance_search_application.get_empty_introducer) {
          this.filter_values.introducers.unshift(0);
        }
        if (this.advance_search_application.get_empty_lender) {
          this.filter_values.lenders.unshift(0);
        }
        if (this.advance_search_application.get_empty_agent) {
          this.filter_values.agents.unshift(0);
        }
      }
    },
    resetFilters() {
      let advance_search_application = {
        isPipelineViewOn: false,
        active: false,
        brokers:[],
        stage: [],
        statuses:[],
        lenders:[],
        introducers: [],
        loan_asset_types:[],
        pod : null,
        start_date: null,
        end_date :  null,
        status_start_date: null,
        status_end_date: null,
        pods: [],
        searchPods: [],
        searchBrokers: [],
        searchStatus: [],
        agents: [],
        applicant_type: null,
        model_year: null,
        model_make: null,
        model: null,
      };
      this.filter_values = {
        brokers: [],
        introducers: [],
        lenders: [],
        agents: [],
      }
      this.$store.commit(
        "set_advance_search_application",
        advance_search_application
      );
      this.range = '';
      this.loan_asset_types = [];
    },
    blurDropdown(event) {
      this.$refs[event].isMenuActive = false;
      this.isActiveChips = false;
      this.setBgColorDropdown();
    },
    toggleDropdownPreview(type, isActive) {
      if (isActive) {
        this.showDropdown[type] = true;
      } else {
        this.showDropdown[type] = false;
      }
    },
    showError(title, message){
      this.error_dialog.title = title;
      this.error_dialog.content = message;
      this.error_dialog.show = true;
    },
    async fetch_all_make() {
      await this.$store.dispatch("load_all_make");
    },
    async fetch_model_by_make() {
      if (this.advance_search_application.model_make) {
        let payload = {
          make: this.advance_search_application.model_make,
        };
        await this.$store.dispatch("load_model_make", payload);

      }
    },
  },
  data() {
    return {
      temporaryPodSelection: [],
      temporaryChildPodSelection: [],
      showAssetFilters: false,
      selectedLenders: '',
      error_dialog: {
        show: false,
        title: '',
        content: '',
      },
      ranges: {
        'thisWeek': 'This Week',
        'lastWeek': 'Last Week',
        'month': 'Last Month',
        'quarter': 'Last Quarter',
        'allTime' : 'All Time'
      },
      empty_broker: {
        email: "",
        id: 0,
        name: "Applications without Broker",
        name_detail: {
          first_name: "",
          last_name: "",
        },
        role: "broker",
      },
      empty_introducer: {
        email: "",
        id: 0,
        name: "Applications without Referrer",
        name_detail: {
          first_name: "",
          last_name: "",
        },
        role: "referrer",
      },
      empty_lender: {
        id: 0,
        name: "Applications without Lender",
      },
      empty_agent: {
        email: "",
        id: 0,
        name: "Applications without Agent",
        name_detail: {
          first_name: "",
          last_name: "",
        },
        role: "agent",
      },
      range: '',
      fromDate: '',
      toDate: '',
      loan_asset_types: [],
      filter_values: {
        brokers: [],
        introducers: [],
        lenders: [],
        agents: [],
      },
      isActiveChips: false,
      showDropdown: {
        pods: false,
        agents: false,
        brokers: false,
        referrers: false,
        lenders: false,
        statuses: false,
        asset_types: false,
        applicant_type: false,
      },
      bgColorClass: undefined,
      showStatusDateFilter: false,
    }
  },
  created() {
    this.advance_search_application.start_date = null;
    this.advance_search_application.end_date = null;

    this.advance_search_application.model_year = null;
    this.advance_search_application.model_make = null;
    this.advance_search_application.model = null;

    this.$store.dispatch('get_basket_search_filter')
    this.$store.dispatch('get_broker_query',false)
    this.$store.dispatch('get_referrer_query', false)
    this.$store.dispatch('get_lender_query', false)
    this.$store.dispatch('get_agent_query', false)
    this.$store.dispatch('fetch_administration_app_status_types', false)
  },
  watch: {
    range(newRange) {
      this.setDateRange(newRange)
    },
    loan_asset_types(newTypes) {
      this.setAssetTypes(newTypes);
    },
    "filter_values.brokers"() {
      this.setAdvancedSearchApplication("brokers");
    },
    "filter_values.introducers"() {
      this.setAdvancedSearchApplication("introducers");
    },
    "filter_values.agents"() {
      this.setAdvancedSearchApplication("agents");
    },
    "filter_values.lenders"() {
      this.setAdvancedSearchApplication("lenders");
    },
    "advance_search_application.model_make"() {
      this.advance_search_application.model = null;
      this.fetch_model_by_make();
    },
  },
  computed: {
    podIcon () {
      if (this.allPods) return 'mdi-close-box'
      if (this.somePods) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
    statusIcon() {
      if (this.allStatus) return 'mdi-close-box'
      if (this.someStatus) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
    somePods () {
      return this.advance_search_application.pods.length > 0 && !this.allPods
    },
    allPods () {
      this.searchPods = this.$store.state.administration_pods ?? this.$store.state.user.user_pods ?? [];
      return this.advance_search_application.pods.length === this.searchPods.length
    },
    someBrokers () {
      return this.filter_values.brokers.length > 0 && !this.allBrokers
    },
    allBrokers () {
      this.searchBrokers = this.getBrokers;
      return this.filter_values.brokers.length === this.searchBrokers.length
    },
    someStatus () {
      return this.filter_values.brokers.length > 0 && !this.allBrokers
    },
    allStatus () {
      this.searchStatus = this.getAppStatusTypes;
      return this.advance_search_application.statuses.length === this.searchStatus.length
    },
    ...mapGetters([
      "options",
      "user",
      "advance_search_application",
      "userHasRole",
      "all_makers",
      "models_make",
    ]),
    permissions() {
      return this.application_update_status_dialog &&
        this.application_update_status_dialog.application
        ? this.application_update_status_dialog.application.permissions
        : null;
    },
    getBrokers() {
        if (this.$store.state.administration_brokers) {
            return [this.empty_broker, ...this.$store.state.administration_brokers];
        }
        return [this.empty_broker];
    },
    getIntroducers() {
      if (this.$store.state.administration_introducers) {
        return [this.empty_introducer, ...this.$store.state.administration_introducers];
      }
      return [this.empty_introducer];
    },
    getAssetTypes() {
      return this.$store.getters.options.loan_asset_type;
    },
    getAppStatusTypes() {
      return this.$store.state.administration_app_status_types ?? [];
    },
    getPods() {
      return this.$store.state.administration_pods ?? this.$store.state.user.user_pods ?? [];
    },
    getLenders() {
      if (this.$store.state.administration_lenders) {
        return [this.empty_lender, ...this.$store.state.administration_lenders];
      }
      return [this.empty_lender];
    },
    getAgents() {
      if (this.$store.state.administration_agents) {
            return [this.empty_agent, ...this.$store.state.administration_agents];
        }
        return [this.empty_agent];
    },
  },
  mounted() {
    this.setExistedFilterValues();

    if (this.userHasRole("super-admin"
    || this.userHasRole("Compliance Officer"))) {
      this.showStatusDateFilter = true;
    }
  },
  async beforeCreate() {
    const params = {
      types: [
        'loan_asset_type',
        'model_years',
      ],
    }
    await this.$store.dispatch('fetch_types', { params });
  },
}
</script>

<style scoped>
.md-layout {
  padding-bottom: 1em;
}
</style>
<style>
.lightgreen {
  background-color: #2E348540 !important;
}

.statusFilterContainer {
  max-width: 400px;
}
.dateFilterContainer {
  max-width: 600px;
}

@media (min-width: 700px) {
  .dropdownContainer {
    max-width: 1373px;
  }
  .fullContainer {
    width: 100%;
  }
}

@media (min-width: 1200px) {
  .fullContainer {
    width: 100%;
    display: flex;
  }
}
</style>
